// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__maqL_","item":"PaymentsMobile_item__uDr8r","label":"PaymentsMobile_label__1nyGz","amount":"PaymentsMobile_amount__1SfMr"};